import * as React from 'react';
import FormView from 'components/FormView';
import { IInvoiceSalesAuditFields } from '../interfaces';

class InvoiceSalesAudit extends React.PureComponent<IInvoiceSalesAuditFields> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/sales-invoice-enquiry/sales-audit':
          onInitialLoad('SalesAudit');
          break;
        case '/sales-invoice-enquiry/sales-audit/audit-details':
          onInitialLoad('SalesAuditDetails');
          break;
        default:
          onInitialLoad('SalesAudit');
      }
    }
  }
  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading, summaryTableRenderer, auditDetailsSummary } = this.props;

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={auditDetailsSummary}
          operationMode={operationMode}
          enableReinitialize={true}
          summaryTableRenderer={summaryTableRenderer}
        />
      </React.Fragment>
    );
  }
}

export default InvoiceSalesAudit;
